module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700.woff2?92425c623934facef057b0cfe2e13f95";